import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {lastValueFrom, take} from "rxjs";
import {environment} from "../../../environments/environment";
import {APP_CONSTANTS} from "../../app.constants";
import {selectUserRoles} from "../../store/reducers/auth.reducer";

export const adminGuard: CanActivateFn = async () => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);

  const roles = await lastValueFrom(store.select(selectUserRoles).pipe(take(1)));

  if (roles === null) {
    await router.navigate([APP_CONSTANTS.UNAUTHORISED_ROUTE]);
    return false;
  }

  const authorised = roles.filter(value => value === environment.adminGroupName).length > 0;

  if (authorised) {
    return true;
  } else {
    await router.navigate([APP_CONSTANTS.UNAUTHORISED_ROUTE]);
    return false;
  }
};
